'use strict';

/**
 * Model for a single collection field
 *
 * @category   Collection
 * @module     base
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Model = require('base/Colido.Model');

var CollectionFieldModel = Model.extend({
    api: '/core/columns',

    idAttribute: 'fieldName',

    defaults: {},

    parse: function (attrs, options) {
        if (!attrs.displayname) {
            attrs.displayname = attrs.fieldname;
        }

        return attrs;
    },

    customAttributes: {
        name: function(){
            return App.t('collection::inputfields:' + _.camelToHyphen(this.get('key')) + ':name');
        },
    },
});

module.exports = CollectionFieldModel;